import { render, staticRenderFns } from "./survey-step-ckd-stage.vue?vue&type=template&id=c3dc43e2"
import script from "./survey-step-ckd-stage.vue?vue&type=script&lang=js"
export * from "./survey-step-ckd-stage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports